import { getEntityRef } from "@client/content/lib/helper";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type EntityRef } from "@client/types";
import React from "react";
import { setActiveLessonId, setActiveSectionId, setActiveSectionIndex } from "../actions";
import { getUrlState } from "../lib";
import { localStateSelector, makeActiveSectionSelector, makeSectionsSelector } from "../selectors";
import { type CourseDetail } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = EntityRef & {
  navigationType: CourseDetail.View.NavigatonType;
  style?: React.CSSProperties;
};
const makeMapStateToProps = () => {
  const activeSectionSelector = makeActiveSectionSelector();
  const sectionsSelector = makeSectionsSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    const sections = sectionsSelector(state, props);
    const urlState = getUrlState();
    const activeItemIndex = urlState.csid ? sections.findIndex((s) => s.id === urlState.csid) : 0;
    return {
      ...props,
      activeItemIndex: props.navigationType === "accordion" ? activeItemIndex : undefined,
      modules: sections,
      module: props.navigationType === "accordion" ? null : activeSectionSelector(state, props),
      activeCourse: localState.activeCourse
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onGoBack: () => dispatch(setActiveSectionId({ ...getEntityRef(props), sectionId: null })),
  onModuleSelected: (index: number) => dispatch(setActiveSectionIndex(getEntityRef(props), index)),
  onLessonClick: (lessonId: string) => dispatch(setActiveLessonId({ lessonId, ...getEntityRef(props) }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
